import TopNavBar from '../../components/reusables/topNavBar';
import MenuTable from './components/menuTable';

function Menu() {
    return (
        <div className='h-full flex flex-col'>
            <TopNavBar title={"Cardápio"} subtitle={"Gerencie o cardápio ativo para venda."} />
            <div className='mx-4 sm:mx-10 my-6 flex-1 font-poppins text-custom_lighter_gray_font'>
                <MenuTable />
            </div>
        </div>
    )

}

export default Menu